module.exports = __webpack_public_path__ + "double-anno-ru-mobile.jpg";